export const REACT_TOKEN_AUTH = localStorage.getItem("REACT_TOKEN_AUTH");
export const REACT_USER_ID = localStorage.getItem("REACT_USER_ID");
export const logged = REACT_TOKEN_AUTH ? true : false;
